import React from 'react';

export default function FolderCardLoader() {
  return (
    <div className='rounded-3xl shadow-three p-5 animate-pulse'>
      <div className='flex justify-between items-center'>
        <div className='w-40 h-10 rounded-md bg-slate-200'></div>
        <div className='w-4 h-6 rounded-sm bg-slate-200'></div>
      </div>
      <div className='mt-6'>
        <div className='w-60 h-6 mb-3 rounded-md bg-slate-200'></div>
        <div className='w-60 h-6 rounded-md bg-slate-200'></div>
      </div>
      <div className='mt-6 flex'>
        <div className='w-12 h-12 rounded-full bg-slate-200'></div>
        <div className='w-40 ml-4 h-12 rounded-md bg-slate-200'></div>
      </div>
    </div>
  );
}
